import React  from "react";
import "./style.css";

export const Label =({text=""})=>  <label className="label-name">{text}</label>